import React from "react";
import moment from "moment";
import "moment/locale/es";
import { withTranslation } from "react-i18next";
import {
  LocalStorageService,
  UserService,
  ClientDocument,
  ContractorService,
  CategoryService,
  ClientService
} from "../../../services";
import { DocumentsToRequireView } from "../../views";
import { DocumentsToRequireValidator } from "../../../validators";
import { convertToStandarDate, getNavigatorTimezone } from "../../../utils";

class DocumentsToRequireAction extends React.Component {

  /**
   * @function createClientDocument
   * @description Creates or updates a client document template.
   * @date 05-02-2026
   * @param {Object} body - Document information to create or update.
   * @param {String} token
   * @returns {Promise<void>}
   */
  createClientDocument = async (body, token) => {
    try {
      this.setState({ isCreatingDocument: false })
      this.toggleLoadingRequesting(true)

      await this.ClientDocument.createOrUpdateDocumentTemplate(body, token)

      this.toggleLoadingRequesting(false)
      this.toggleCompletedRequesting(
        true,
        this.props.t('documentsToRequire.documentCreatedSuccess'),
        null,
        'create-document'
      )

      await this.loadDocuments()

      setTimeout(() => {
        this.setState({ isCreatingDocument: false })
      }, 4000)

    } catch (error) {
      this.setState({ isCreatingDocument: false })
      this.toggleLoadingRequesting(false)

      let errorMessage = this.props.t('documentsToRequire.documentCreationError')

      if (error.response && error.response.status === 500) {
        errorMessage = this.props.t('documentsToRequire.errors.duplicateDocumentName')
      } else if (error.message) {
        errorMessage = error.message
      }

      this.toggleErrorRequesting(
        errorMessage,
        4000,
        false
      )
    }
  }

  /**
   * @function loadDocuments
   * @description Retrieves the client's classified documents.
   * @date 05-02-2026
   * @returns {Promise<void>}
   */
  loadDocuments = async () => {
    const documentsData = await this.ClientDocument.getClassifiedDocuments(this.token)
    const documentsArray = documentsData?.data.data?.documents || []

    const documents = documentsArray.map(documento => {
      let convertDate = convertToStandarDate(documento.updatedDate, this.language)
      const standarDate =
        convertDate !== 'invalid date'
          ? convertDate
          : documento.updatedDate

      const groupsArray = documento.groups || []
      const groupName = groupsArray.length > 0
        ? groupsArray.map(g => g.name).join(', ')
        : 'Sin grupo'

      return {
        ...documento,
        groups: groupsArray,
        groupName,
        newUpdatedDate: `${this.props.t(
          'documentsToRequire.grid.modifiedOn'
        )} ${standarDate}`,
        clientDocumentTypeRequestId:
          documento.clientDocumentTypeRequestId ?? 0,
        clientDocumentTypeRequest:
          documento.clientDocumentTypeRequest ?? { name: 'Sin definir' }
      }
    })

    this.setState({ documents })
  }

  updateClientDocument = async (body, token) => {
    try {
      this.toggleLoadingRequesting(true)
      let response
      if (body.groups && body.groups.length > 0) {
        // Usar el endpoint de templates
        response = await this.ClientDocument.createOrUpdateDocumentTemplate(body, token)
      } else {
        // Usar el endpoint legacy
        response = await this.ClientDocument.updateClientDocument(body, token)
      }
      this.toggleLoadingRequesting(false)
      this.toggleCompletedRequesting(true, this.props.t('documentsToRequire.documentUpdatedSuccess'))
      // Refrescar documentos
      await this.componentDidMount()
    } catch (error) {
      this.toggleLoadingRequesting(false)
      this.toggleErrorRequesting(error.message || this.props.t('documentsToRequire.documentUpdateError'), 4000, false)
    }
  }



  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showLoadingRequesting: false,
      showErrorRequesting: false,
      showCompletedRequesting: false,
      messageError: '',
      user: {},
      documents: [],
      token: "",
      shouldRefresh: false,
      showDialogYesNo: false,
      dataItemUser: {},
      personTypes: [],
      typeDocuments: [],
      preferenceValue: false,
      selectedFile: null,
      selectedFileName: '',
      errorFile: false,
      selectedFileBase64: "",
      colorBorderContainer: "gray",
      newOptions: [],
      availableGroups: [],
      shouldReopenClassifyModal: false,
      successContext: null // 'delete' | 'create-document' | 'create-group' | 'classify'
    };
  }

  token = {};
  url = process.env.REACT_APP_MIFIRMA_API;
  localStorageService = new LocalStorageService();
  UserService = new UserService(this.url);
  contractorService = new ContractorService(this.url)
  ClientDocument = new ClientDocument(this.url);
  categoryService = new CategoryService(this.url);
  clientService = new ClientService(this.url)
  validators = DocumentsToRequireValidator(this.props.t);
  timezone = getNavigatorTimezone()
  goBackRoute = '/configuration'
  language = 'es'
  ENV = process.env

  async componentDidMount() {
    this.toggleLoadingView(true)

    this.token = this.localStorageService.getLocalStorageItem("token").idToken
    const user = this.localStorageService.getLocalStorageItem("user")

    this.language = new LocalStorageService().getLocalStorageItem("preferredLanguage") || "es"
    moment.locale(this.language)

    await this.loadDocuments()
    this.getPersonType()
    this.getDocumentTypes()
    this.getPreferences()
    this.getAllClientDocumentTypeRequest()
    this.getAvailableGroups()

    this.setState({
      user,
      token: this.token,
      loading: false
    })
  }

  toggleLoadingView = (value) => {
    this.setState({
      loading: value
    })
  }

  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value,
    });
  };

  toggleErrorRequestingFalse = () => {
    this.setState({
      showErrorRequesting: false
    })
  }

  toggleErrorRequesting = (message, time, sendInbox, path) => {
    let sendTo = (path && path !== '') ? path : "/"
    this.setState({
      showErrorRequesting: true,
      messageError: message
    }, () => {
      setTimeout(() => {
        this.setState({
          showErrorRequesting: false,
        })
        if (sendInbox) {
          const locationState = this.props.location.state
          if (locationState && locationState.from) {
            this.props.history.push({
              pathname: locationState.from,
              state: locationState
            })
          } else {
            this.props.history.push(sendTo)
          }
        }
      }, time || 4000)
    })
  }

  toggleCompletedRequesting = (value, message, documents, context) => {
    this.setState(
      {
        showCompletedRequesting: value,
        message,
        successContext: context || null
      },
      () => {
        setTimeout(() => {
          this.setState(prevState => ({
            showCompletedRequesting: false,
            message: "",
            documents: Array.isArray(documents)
              ? documents
              : prevState.documents,
            shouldReopenClassifyModal:
              prevState.successContext === 'create-group'
          }))
        }, 4000)
      }
    )
  }

  //DialogYesNoHLpure funtion to show o not show
  toggleDialogYesNo = (dataItem, value) => {
    this.setState({
      dataItemUser: dataItem,
      showDialogYesNo: value,
    });
  };

  getPersonType = async () => {
    try {
      let contractorPersonType = await this.contractorService.getPersonTypeByKey('documentType', this.token)
      if (contractorPersonType && contractorPersonType.data && Number(contractorPersonType.statusCode) === 200) {
        let personTypes = contractorPersonType.data

        personTypes.sort((a, b) => a.id - b.id)
        personTypes.map((type) => {
          type.personType = `${this.props.t(`documentsToRequire.document.type.key.${type.key}`)}`;
          type.name = type.key
          return type
        })

        const placeholderFilter = {
          name: this.props.t("documentsToRequire.document.type.key.all"),
          personType: this.props.t("documentsToRequire.document.type.key.all")
        }
        personTypes.unshift(placeholderFilter);
        this.setState({
          personTypes,
          loading: false
        })
      } else {
        this.props.history.push(this.goBackRoute);
        this.setState({
          loading: false,
        });
      }
    } catch (error) {
      this.props.history.push(this.goBackRoute);
      this.setState({
        loading: false,
      });
    }
  }

  /**
   * @function getDocumentTypes
   * @description Retrieves the available document types and filters only those related to the document module.
   * @date 05-02-2026
   * @returns {Promise<void>}
   */
  getDocumentTypes = async () => {
    try {
      const responseDocType = await this.categoryService.getTypeDocuments(this.token, 'Documento');
      if (responseDocType.statusCode == 200 && responseDocType.data) {
        let typeDocumentOptions = responseDocType.data;
        typeDocumentOptions.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));

        // Filter only "Documento" infoType
        const onlyTypeDocument = typeDocumentOptions.filter(td => { return td.infoType === this.ENV.REACT_APP_DIGITAL_VAULT_DOCUMENT })

        this.setState({
          typeDocuments: onlyTypeDocument
        })
      } else {
        this.props.history.push(this.goBackRoute);
        this.setState({
          loading: false,
        });
      }
    } catch (error) {
      this.props.history.push(this.goBackRoute);
      this.setState({
        loading: false,
      });
    }
  }

  getPreferences = async () => {
    try {
      let preferences = await this.clientService.getClientPreferences(this.token, this.timezone);
      if (preferences && preferences.data && Number(preferences.statusCode) === 200) {
        let preferenceProcedureUser = preferences.data.find((preference) => preference.preferenceName === process.env.REACT_APP_PREFERENCE_PROCEDURES_CONTROL)
        let preferenceValue = (preferenceProcedureUser) ? preferenceProcedureUser.booleanValue : false
        this.setState({
          preferenceValue
        })
      } else {
        this.props.history.push(this.goBackRoute);
        this.setState({
          loading: false,
        });
      }
    } catch (error) {
      this.props.history.push(this.goBackRoute);
      this.setState({
        loading: false,
      });
    }
  }

  handleFile = async (e) => {
    if (!e || !e.target || !e.target.files || e.target.files.length === 0) return
    this.setState({
      selectedFile: e.target.files[0],
      selectedFileName: e.target.files[0].name,
      errorFile: false,
      colorBorderContainer: "green",
    });

    // Upload the base64 in the state
    let fileBase64 = await this.pdfToBase64(e.target.files[0]);
    let pdfBase64 = fileBase64.split(",")[1];
    this.setState({ selectedFileBase64: pdfBase64 });
  };

  handleDeleteFile = (e) => {
    this.setState({
      selectedFile: null,
      errorFile: false,
      selectedFileBase64: "",
      colorBorderContainer: "gray",
    });
    return true;
  };

  pdfToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    }
    );

  getAllClientDocumentTypeRequest = async () => {
    try {
      let clientDocumentsTypes = await this.ClientDocument.getAllClientDocumentTypeRequest(this.token)
      if (!clientDocumentsTypes || !clientDocumentsTypes.data || Number(clientDocumentsTypes.statusCode) !== 200) throw new Error('Ocurrió un error al consultar la clasficación de documentos')

      let typesClientDocuements = clientDocumentsTypes.data.map((type) => {
        type.name = this.props.t(`documentsToRequire.typeRequest.name.${type.name}`)
        type.value = type.id
        return type
      })

      this.setState({
        newOptions: typesClientDocuements
      })
    } catch (error) {
      this.props.history.push(this.goBackRoute);
      this.setState({
        loading: false,
      });
    }
  }

  /**
   * @function getAvailableGroups
   * @description Retrieves the available groups for document classification.
   * @date 05-02-2026
   * @returns {Promise<void>}
   */
  getAvailableGroups = async () => {
    try {
      const response = await this.ClientDocument.getClassifiedDocuments(this.token)

      if (response && response.data && response.data.data) {
        const groupsData = response.data.data.groups || []

        const groups = groupsData.map(group => ({
          id: group.id,
          name: group.name,
          value: group.id,
          selected: false
        }))

        const noGroupOption = {
          id: 'no-group',
          name: this.props.t('documentsToRequire.filter.noGroup'),
          value: 'no-group',
          selected: false
        }

        const allGroups = [...groups, noGroupOption]
        allGroups.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))

        this.setState({ availableGroups: allGroups })
      }
    } catch (error) {
      this.setState({ availableGroups: [] })
    }
  }

  /**
   * @function createGroup
   * @description Creates a new document classification group.
   * @date 05-02-2026
   * @param {Object} newGroup - New group information.
   * @returns {Promise<void>}
   */
  createGroup = async (newGroup) => {
    try {
      this.toggleLoadingRequesting(true)

      const response = await this.ClientDocument.createGroup(
        { name: newGroup.name, id: null },
        this.token
      )

      this.toggleLoadingRequesting(false)

      if (response && Number(response.statusCode) === 200) {

        this.toggleCompletedRequesting(
          true,
          this.props.t('documentsToRequire.groupCreatedSuccess'),
          null,
          'create-group'
        )

        this.getAvailableGroups()
      } else {
        throw new Error('Error al crear grupo')
      }
    } catch (error) {
      this.toggleLoadingRequesting(false)
      this.toggleErrorRequesting(
        error.message || this.props.t('documentsToRequire.groupCreationError'),
        4000,
        false
      )
    }
  }

  /**
   * @function classifyDocument
   * @description Associates one or more groups with a document or template and updates the classified documents list.
   * @date 05-02-2026
   * @param {Object} documentData
   * @param {Array} groups - List of selected groups.
   * @param {Number} [templateId] - Optional template ID.
   * @returns {Promise<void>}
   */
  classifyDocument = async (documentData, groups, templateId) => {
    try {
      this.toggleLoadingRequesting(true)

      const classifyData = {
        templateId: templateId || documentData.id || 6,
        groups: groups.map(g => ({
          id: g.id,
          name: g.name,
          value: g.value
        }))
      }

      const response = await this.ClientDocument.saveClassifyDocument(classifyData, this.token)

      if (response && Number(response.statusCode) === 200) {
        this.toggleLoadingRequesting(false)
        this.toggleCompletedRequesting(
          true,
          this.props.t('documentsToRequire.classificationSaved')
        )

        const documentsData = await this.ClientDocument.getClassifiedDocuments(this.token)
        const documentsArray = documentsData?.data.data?.documents || []

        const documents = documentsArray.map(documento => {
          let convertDate = convertToStandarDate(documento.updatedDate, this.language)
          const standarDate =
            convertDate !== 'invalid date'
              ? convertDate
              : documento.updatedDate

          const groupsArray = documento.groups || []
          const groupName = groupsArray.length > 0
            ? groupsArray.map(g => g.name).join(', ')
            : 'Sin grupo'

          return {
            ...documento,
            groups: groupsArray,
            groupName: groupName,
            newUpdatedDate: `${this.props.t(
              'documentsToRequire.grid.modifiedOn'
            )} ${standarDate}`,
            clientDocumentTypeRequestId:
              documento.clientDocumentTypeRequestId ?? 0,
            clientDocumentTypeRequest:
              documento.clientDocumentTypeRequest ?? { name: 'Sin definir' },
          }
        })

        this.setState({ documents })
      } else {
        throw new Error('Error al clasificar documento')
      }
    } catch (error) {
      this.toggleLoadingRequesting(false)
      this.toggleErrorRequesting(
        error.message || this.props.t('documentsToRequire.classificationError'),
        4000,
        false
      )
    }
  }

  clearReopenClassifyModal = () => {
    this.setState({ shouldReopenClassifyModal: false })
  }

  render() {
    return (
      <DocumentsToRequireView
        {...this.state}
        history={this.props.history}
        validators={this.validators}
        toggleCompletedRequesting={this.toggleCompletedRequesting}
        toggleLoadingRequesting={this.toggleLoadingRequesting}
        toggleErrorRequesting={this.toggleErrorRequesting}
        toggleErrorRequestingFalse={this.toggleErrorRequestingFalse}
        toggleDialogYesNo={this.toggleDialogYesNo}
        handleDeleteFile={this.handleDeleteFile}
        handleFile={this.handleFile}
        goBackRoute={this.goBackRoute}
        language={this.language}
        classifyDocument={this.classifyDocument}
        createGroup={this.createGroup}
        shouldReopenClassifyModal={this.state.shouldReopenClassifyModal}
        createClientDocument={this.createClientDocument}
        updateClientDocument={this.updateClientDocument}
        clearReopenClassifyModal={this.clearReopenClassifyModal}
      />
    );
  }
}

export default withTranslation()(DocumentsToRequireAction);
